import {
    addEmploymentsToReview,
    createReview,
    getAllOrganisationNodes,
    getAssessmentPublishKeyValues,
    getBudgetPublishKeyValues,
    getFilterSelectionEmploymentKeyValues,
    getLatestSyncJob,
    getMissingTableData,
    getNewFilterTableData,
    getResultKeyValues,
    getResultPerformanceChartKeyValues,
    getReviewByReviewDraftId,
    getReviewBySalaryReviewId,
    getReviewSettings,
    getexcludedtabledata,
    ignoreMissingEmployments,
    publishBudgets,
    publishPerformanceAssessment,
    removeEmploymentsFromReview,
    unPublishBudgets,
    unPublishPerformanceAssessment,
    updateReview,
    updateactivatesendnewsalaries,
    activeSalaryReviewList,
    activeSalaryReviewListV2,
    setSyncJobTimout,
    getCurrencyConversions,
    getManagerIndividualBudgetKeyValues,
    abort as abortPayManagement
} from '@/newApi/controllers/payManagement/Reviews';
import {
    getAttestationTableData,
    getEmployeePerformanceChartData,
    getEmployeeSalaryHistoryChartData,
    getEmploymentHourlyKeyValues,
    getEmploymentMonthlyKeyValues,
    getEmploymentPerformanceKeyValues,
    getFailedSyncIds,
    getResultTableData,
    getSalaryReviewEmploymentById,
    getSalaryReviewEmployments,
    getSyncData,
    getSyncDataSummary,
    syncEmploymentData,
    updateSalaryReviewEmployment,
    updateSalaryReviewEmploymentViaUnion,
    abort as abortReviewEmployment
} from '@/newApi/controllers/payManagement/ReviewEmployment';
import {
    createReviewDraft,
    deleteReviewDraft,
    getAllReviewDrafts,
    getEmployments,
    getReviewDraftById,
    updateReviewDraft,
    abort as abortReviewDraft
} from '@/newApi/controllers/payManagement/ReviewDrafts';
import {
    createIndividualBudget,
    deleteIndividualBudget,
    getIndividualBudgetById,
    getIndividualBudgetByReviewId,
    getIndividualBudgetEmployments,
    getIndividualBudgetKeyValues,
    getIndividualBudgetSummaryKeyValues,
    getIndividualBudgetsCollection,
    updateIndividualBudget,
    individualBudgetValues,
    abort as abortIndividualBudget
} from '@/newApi/controllers/payManagement/IndividualBudgets';
import {
    createOrganisationNodeBudget,
    deleteOrganisationNodeBudget,
    getOrganisationNodeBudgetKeyvalues,
    getOrganisationNodeBudgetsCollection,
    getOrganisationNodeSummaryKeyValues,
    getOrganisationNodes,
    updateOrganisationNodeBudget,
    organisationBudgetValues,
    abort as abortOrganisationNodeBudget
} from '@/newApi/controllers/payManagement/OrganisationNodeBudgets';
import { getBudgetOverviewKeyValues, getLegacyBudget, deleteLegacyBudget, getBudgetStatus, getBudgetPublishStatus, abort as abortBudget } from '@/newApi/controllers/payManagement/Budget';
import { getPerformanceAssessmentOverviewKeyValues, getPerformanceAssessmentPublishStatus } from '@/newApi/controllers/payManagement/PerformanceAssessment';
import { getAttestationOverviewKeyValues } from '@/newApi/controllers/payManagement/Attestation';
import { getSalaryReviewMenuList, getSalaryReview, getUnionSalaryReviewEmployments, abort as abortUnion } from '@/newApi/controllers/payManagement/Union';
import { createSalaryReviewKeyFiguresReport, abort as abortReports } from '@/newApi/controllers/payManagement/Reports';

function abort(): void {
    abortPayManagement();
    abortReviewEmployment();
    abortReviewDraft();
    abortIndividualBudget();
    abortOrganisationNodeBudget();
    abortBudget();
    abortUnion();
    abortReports();
}

export const PayManagement = {
    abort,
    addEmploymentsToReview,
    createIndividualBudget,
    createOrganisationNodeBudget,
    createReview,
    createReviewDraft,
    deleteIndividualBudget,
    deleteLegacyBudget,
    deleteOrganisationNodeBudget,
    deleteReviewDraft,
    getAllOrganisationNodes,
    getAllReviewDrafts,
    getAssessmentPublishKeyValues,
    getAttestationOverviewKeyValues,
    getAttestationTableData,
    getBudgetOverviewKeyValues,
    getBudgetPublishKeyValues,
    getBudgetStatus,
    getEmployeePerformanceChartData,
    getEmployeeSalaryHistoryChartData,
    getEmploymentHourlyKeyValues,
    getEmploymentMonthlyKeyValues,
    getEmploymentPerformanceKeyValues,
    getEmployments,
    getFailedSyncIds,
    getFilterSelectionEmploymentKeyValues,
    getIndividualBudgetById,
    getIndividualBudgetByReviewId,
    getIndividualBudgetEmployments,
    getIndividualBudgetKeyValues,
    getIndividualBudgetSummaryKeyValues,
    getIndividualBudgetsCollection,
    getLegacyBudget,
    getMissingTableData,
    getNewFilterTableData,
    getOrganisationNodeBudgetKeyvalues,
    getOrganisationNodeBudgetsCollection,
    getOrganisationNodeSummaryKeyValues,
    getOrganisationNodes,
    getPerformanceAssessmentOverviewKeyValues,
    getPerformanceAssessmentPublishStatus,
    getResultKeyValues,
    getResultPerformanceChartKeyValues,
    getResultTableData,
    getReviewByReviewDraftId,
    getReviewBySalaryReviewId,
    getLatestSyncJob,
    getReviewDraftById,
    getReviewSettings,
    getSalaryReviewEmploymentById,
    getSalaryReviewEmployments,
    getBudgetPublishStatus,
    getSyncData,
    getSyncDataSummary,
    getexcludedtabledata,
    ignoreMissingEmployments,
    publishBudgets,
    publishPerformanceAssessment,
    removeEmploymentsFromReview,
    syncEmploymentData,
    unPublishBudgets,
    unPublishPerformanceAssessment,
    updateIndividualBudget,
    updateOrganisationNodeBudget,
    updateReview,
    setSyncJobTimout,
    updateReviewDraft,
    updateSalaryReviewEmployment,
    updateactivatesendnewsalaries,
    activeSalaryReviewList,
    activeSalaryReviewListV2,
    individualBudgetValues,
    organisationBudgetValues,
    getCurrencyConversions,
    getSalaryReviewMenuList,
    getSalaryReview,
    getUnionSalaryReviewEmployments,
    updateSalaryReviewEmploymentViaUnion,
    createSalaryReviewKeyFiguresReport,
    getManagerIndividualBudgetKeyValues
};
